import { writable } from "svelte/store"

export const footerHeight = writable(0)
